import { Navbar, Nav, Container } from "react-bootstrap";
import flareSymbol from "../images/blue-green-logo.png";
import Image from "react-bootstrap/Image";

export default function CustomNavbar() {
  return (
    <>
      <Navbar
        bg="white"
        variant="light"
        sticky="top"
        style={{ borderBottom: "1px solid black" }}
        expand="lg"
      >
        <Container
          style={{
            marginLeft: "5%",
            display: "flex",
            alignContent: "center",
          }}
        >
          <Navbar.Brand href="/" style={{ paddingBottom: "0px" }}>
            <Image
              alt=""
              src={flareSymbol}
              height="20"
              className="d-inline-block align-top"
            />{" "}
          </Navbar.Brand>
          <a href="/" style={{ textDecoration: "none", color: "black" }}>
            <h4>Spark</h4>
          </a>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" defaultActiveKey="">
              {/* <Nav.Link href="/">Home</Nav.Link> */}
              {/* <Nav.Link href="/commonapp">Developers</Nav.Link> */}
              {/* <Nav.Link href="/marketplace">For Investors</Nav.Link> */}
              {/* <Nav.Link href="/vendors">Vendors</Nav.Link> */}
              {/* <Nav.Link href="/incentives">Resources</Nav.Link> */}
              {/* <Nav.Link href="/communitysolar">
                Community Solar Directory
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
